define('models/activities/posts/postitem',["backbone",
        "models/messages/comments_collection",
        "models/shared/image/image_collection"
], function (Backbone, CommentsCollection, ImageCollection) {
    var Post = Backbone.Model.extend({

        url: function () {
            var url = pf.accountsURL + "/Posts/" + this.PostGUID + "/" + this.showFlaggedItems;
            return url;
        },
        parse: function (data) {
            var response = {};

            //response.PostID = data.CID;
            response.PostGUID = data.PGID;
            response.AccountName = data.AN;
            //response.AccountID = data.AID;
            response.ParentPostID = data.PPID;
            response.AuthorGUID = data.G;
            response.AccountGUID = data.AG;
            response.AccountTypeID = data.ATID;
            response.PostBody = data.PB != null ? unescape(data.PB) : "";
            response.PostTitle = data.PT;
            response.AuthorUserID = data.AUID;
            response.AuthorUser = data.A;
            response.AuthorImage = buildImageURL(pf.enums.entityTypeCodeEnum.User, data.G, pf.enums.imageTypeGUIDEnum.Thumbnail, data.AI);//data.AI;
            response.CreatedDT = data.CDT;
            response.LastUpdatedDT = data.LDT;
            response.LastUpdatedByUserID = data.LUID;
            response.RemovedDT = data.RDT;
            response.RemovedByUserID = data.RUID;
            response.RemovedByUser = data.RU;
            response.Replies = data.R;
            response.Views = data.V;
            response.Internal = data.I;
            response.Flagged = data.F;
            response.FlaggedByUserGUID = data.FBUG;
            response.FlaggedRulingID = data.FRID;
            response.FlaggedRulingType = data.FRT;
            response.FlaggedRulingBy = data.FRB;
            response.DeliveryOptions = data.DO;
            //response.IsAlert = data.ALT;
            //response.AlertEndInterval = data.AEI;
            response.CauseUserRoleTypeID = data.CURT;
            response.Comments = new CommentsCollection(data.CM, { parse: true });
            response.PostImages = new ImageCollection(data.IIS, { parse: true });
            response.ParticipantCount = data.PC;
            response.CommentCount = data.CNT;
            response.MarkRead = data.MR;
            response.MaxVersion = data.MV;
            response.CommentNotEnabled = data.CNE;
            response.AccountImageURL = buildImageURL(pf.enums.entityTypeCodeEnum.Account, data.AG, pf.enums.imageTypeGUIDEnum.Thumbnail, data.AIU);
            response.Total = data.T;
            response.Active = true; //data.AC;
            response.ReturnImageType = data.RIT;
            response.PostTypeID = data.PTID;
            response.PostCategoryID = data.PCID;
            response.ManagerGUID = data.MGUID;
            response.AuthorRoleTypeID = data.ARID;
            if (response.PostImages != null && response.PostImages.models.length > 0) {
                response.PostImage = response.PostImages.models[0];
            }
            response.VideoSourceTypeID = data.VST;
            response.VideoID = data.VID;
            response.ParticipantsCanPost = data.PCP ? true : false;

            return response;
        },
        save: function (attributes, options) {
            options = options || {};
            attributes = attributes || {};

            var data = {};
            data.AG = this.attributes.AccountGUID;
            data.PB = this.attributes.PostBody;
            data.PT = this.attributes.PostTitle;
            data.I = this.attributes.Internal;
            data.ALT = this.attributes.IsAlert;
            data.AEI = this.attributes.AlertEndInterval;
            data.DO = this.attributes.DeliveryOptions;
            data.RIT = this.attributes.ReturnImageType;
            data.PGID = this.attributes.PostGUID;
            data.T = this.Total;
            data.PTID = pf.enums.postTypes.ManualCause;
            this.attributes = data;

            return Backbone.Model.prototype.save.call(this, attributes, options);
        },
        initialize: function (options) {
            options = options || {};

            this.showFlaggedItems = options.showFlaggedItems;
            this.PostGUID = options.PGID;
            this.AccountName = options.AN;
            this.ParentPostID = options.PPID;
            this.AuthorGUID = options.G;
            this.AccountGUID = options.AG;
            this.AccountTypeID = options.ATID;
            this.PostBody = options.PB != null ? unescape(options.PB) : "";
            this.PostTitle = options.PT;
            this.AuthorUserID = options.AUID;
            this.AuthorUser = options.A;
            this.AuthorImage = buildImageURL(pf.enums.entityTypeCodeEnum.User, options.G, pf.enums.imageTypeGUIDEnum.Thumbnail, options.AI);//options.AuthorImage;
            this.CreatedDT = options.CDT;
            this.LastUpdatedDT = options.LDT;
            this.LastUpdatedByUserID = options.LUID;
            this.RemovedDT = options.RDT;
            this.RemovedByUserID = options.RUID;
            this.RemovedByUser = options.RU;
            this.Replies = options.R;
            this.Views = options.V;
            this.Internal = options.I;
            this.FlaggedByUserGUID = options.FBUG;
            this.Flagged = options.F;
            this.FlaggedRulingID = options.FRID;
            this.FlaggedRulingType = options.FRT;
            this.FlaggedRulingBy = options.FRB;
            this.DeliveryOptions = options.DO;
            //this.IsAlert = options.ALT;
            //this.AlertEndInterval = options.AEI;
            this.CauseUserRoleTypeID = options.CURT;
            this.Comments = new CommentsCollection(options.CM, { parse: true });
            this.PostImages = new ImageCollection(options.IIS, { parse: true });
            this.ParticipantCount = options.PC;
            this.CommentCount = options.CNT;
            this.MarkRead = options.MR;
            this.MaxVersion = options.MV;
            this.CommentNotEnabled = options.CNE;
            this.AccountImageURL = buildImageURL(enums.entityTypeCodeEnum.Account, options.AG, enums.imageTypeGUIDEnum.Thumbnail, options.AIU);
            this.Total = options.T;
            this.Active = true; //options.AC;
            this.ReturnImageType = options.RIT;
            this.PostTypeID = options.PTID;
            this.PostCategoryID = options.PCID;

            if (this.PostImages != null && this.PostImages.models.length > 0)
            {
                this.PostImage = this.PostImages.models[0];
            }
            this.ManagerGUID = options.MGUID;
            this.AuthorRoleTypeID = options.ARID;
            this.VideoSourceTypeID = options.VST;
            this.VideoID = options.VID;
            this.ParticipantsCanPost = options.PCP ? true : false;
        },
    });
    return Post;
});
